module.exports = __webpack_public_path__ + "img/tau.f68acb20.svg";